export default __webpack_public_path__ + "static/6-child-6876452f3db0c84e43eadc7b8a8ae67b.png";